// angular import
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

// project import
import { AuthResourceService, ConfigResourceService, GenericResourceService } from '@mri/app/resources';
import { filter, interval, mergeMap, Observable, of, Subject, Subscription, tap } from 'rxjs';
import { AnyObject, AuthCache, MobileAlarmEvent } from '@mri/types';
import { Router } from '@angular/router';
import { InstallPromptDialogComponent, LoadingService, SignOutAskDialogComponent } from '@mri/app/modules';
import { MatDialog } from '@angular/material/dialog';
import { catchError, map } from 'rxjs/operators';
import { ChoiceTypes } from '@mri/enums';

@Component({
  selector: 'app-nav-right',
  templateUrl: './toolbar-right.component.html',
  styleUrls: ['./toolbar-right.component.scss']
})
export class NavRightComponent implements OnInit {
  private _sub = new Subscription();
  private _notify$ = new Subject();

  deferredPrompt: AnyObject;
  alarmEvents: Array<MobileAlarmEvent>;
  lastViewNotificationTime?: Date;

  // public props
  @Input() invertColor: boolean;
  @Output() HeaderBlur = new EventEmitter();

  get auth$(): Observable<AuthCache | undefined> {
    return this.authSrv.auth$;
  }

  // constructor
  constructor(
    private translate: TranslateService,
    private authSrv: AuthResourceService,
    private _loadingSrv: LoadingService,
    private _genericSrv: GenericResourceService,
    private _router: Router,
    private _dialogSrv: MatDialog,
    private _configSrv: ConfigResourceService
  ) {
    translate.setDefaultLang('es');

    this._sub.add(
      this._notify$
        .pipe(
          mergeMap(() => this.getAlarmEvents())
        )
        .subscribe()
    );

    this._sub.add(
      interval(1000 * 30)
        .subscribe(() => this._notify$.next(null))
    );

    window.addEventListener('beforeinstallprompt', (event) => {
      event.preventDefault();
      this.deferredPrompt = event;
    });
  }

  ngOnInit() {
    this._notify$.next(null)
  }

  // public method
  // user according language change of sidebar menu item
  useLanguage(language: string) {
    this.translate.use(language);
  }

  headerBlur() {
    this.HeaderBlur.emit();
  }

  // user Logout
  logout() {
    const dialog = this._dialogSrv.open(SignOutAskDialogComponent, {
      autoFocus: false, disableClose: true
    });

    dialog.afterClosed()
      .pipe(
        filter(result => !!result),
        tap(() => this._loadingSrv.visible = true),

        mergeMap(() => this.authSrv.signOut()),
        tap(() => this._router.navigate(['/auth/sign-in'])),
        catchError(() => of(null)),
        tap(() => this._loadingSrv.visible = false)
      ).subscribe();

  }

  cards = [
    {
      icon: 'custom-layer',
      time: '2 min ago',
      position: 'UI/UX Design',
      description:
        'Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley oftype and scrambled it to make a type'
    },
    {
      icon: 'custom-sms',
      time: '1 hour ago',
      position: 'Message',
      description: 'Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500.'
    }
  ];

  cards2 = [
    {
      icon: 'custom-document-text',
      time: '12 hour ago',
      position: 'Forms',
      description:
        'Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500s, when an unknown printer took a galley oftype and scrambled it to make a type'
    },
    {
      icon: 'custom-security-safe',
      time: '18 hour ago',
      position: 'Security',
      description: 'Lorem Ipsum has been the industry\'s standard dummy text ever since the 1500.'
    }
  ];

  notification = [
    {
      sub_title: 'Improvement',
      time: '12 hour ago',
      title: 'Widgets update',
      img: 'assets/images/layout/img-announcement-3.png'
    },
    {
      sub_title: 'New Feature',
      time: '18 hour ago',
      title: 'Coming soon dark mode',
      img: 'assets/images/layout/img-announcement-4.png'
    }
  ];

  getAlarmEvents(): Observable<Array<MobileAlarmEvent>> {

    return this._genericSrv
      .getElements<MobileAlarmEvent>('mobiles/alarms/events', { filter: {}, paginate: { size: 20, page: 1 } })
      .pipe(
        map(response => response.objects),
        tap(objects => this.lastViewNotificationTime = this.lastViewNotificationTime || new Date(objects[objects.length - 1]?.deviceTime)),
        map(objects => objects.map( element => {
          const choices = this._configSrv.getChoices(ChoiceTypes.ALARM);
          const choice = choices.find(c => c.value === element.type);

          return {...element, choice};
        })),
        tap(objects => this.alarmEvents = objects)
      );
  }

  openInstallPrompt() {
    const dialogRef = this._dialogSrv.open(InstallPromptDialogComponent, {
      width: '250px',
      data: { deferredPrompt: this.deferredPrompt }
    });
    dialogRef.afterClosed().subscribe(result => {
      console.log('result', result);
      console.log('El diálogo de instalación fue cerrado');
    });
  }
}
